import { memo } from 'react';
import classes from 'classnames';
import styles from './ProgressBar.module.scss';

export type Props = {
  steps: number;
  currentStep: number;
  className?: string;
};

export default memo(function ProgressBar({
  steps,
  currentStep,
  className,
}: Props) {
  const progress = `${(currentStep / steps) * 100}%`;
  return (
    <div className={classes(styles.bar, className)}>
      <div
        className={styles.fill}
        data-test={`progressbar-${progress}`}
        style={{ width: progress }}
      />
    </div>
  );
});
